<template>
  <div class="container" v-if="$store.state.subProject">
    <Card>
      <v-layout row>
        <v-flex lg8 md8 sm12 xs12>
          <h3>
            <v-icon>mdi-format-list-bulleted</v-icon>Irrigation Instrucctions
            Logs de Riego
          </h3>
        </v-flex>
        <v-flex lg5 md5 sm12 xs12>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="date"
            lazy
            dark
            transition="scale-transition"
            offset-y
            full-width
            min-width="200px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker v-model="date" no-title scrollable>
              <v-spacer />
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="onClick()">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <br />
      <hr />
      <v-layout row>
        <v-flex md12 sm12 lg12 xs12>
          <br />
          <v-btn
            block
            round
            color="light-green"
            dark
            @click="viewInstruction()"
          >
            <v-icon>mdi-waves</v-icon>Today's Irrigation Instruction
          </v-btn>
          <!-- <Table /> -->
          <create-instruction />
        </v-flex>
      </v-layout>
    </Card>
  </div>
</template>

<script>
// import axiosApi from "../axios-api";
import moment from "moment-timezone";
// import splitByHead from "../utils/pulseIrrigationHelpers/splitByHead";
import Card from "../components/material/Card.vue";
import CreateInstruction from "../components/resources/createInstructionTable.vue";

export default {
  components: {
    Card,
    CreateInstruction,
  },
  data() {
    return {
      irrigationInstructions: [],
      pulses: [],
      date: null,
      menu: null,
    };
  },
  created() {
    console.log("CREATED");
  },
  methods: {
    click() {
      // this.$store.commit("modal", true);
      this.viewInstruction();
    },
    viewInstruction: async function() {
      // let arr = [];
      console.log("view", this.irrigationInstructions.length);
      let irrigationInstructions = this.$store.state.irrigationInstructions;

      // IN CASE NO IRRIGATION INSTRUCTION EXISTS
      if (irrigationInstructions.length == 0) {
        let irrigationInstructions = this.$store.state.agroUnits.map((x) => ({
          agroUnitId: x.id,
          index: null,
          name: x.name,
          sector: x.sector,
          cabezal: x.cabezal,
          initialTime: x.initialTime,
          ml: x.ml,
          pH: x.pH,
          comments: "...",
          total: 0,
        }));
        console.log("view", irrigationInstructions);
        // irrigationInstructions.push({});
        // irrigationInstructions.push({});
        let newArr = [];
        newArr.push(irrigationInstructions);
        this.$store.commit("irrigationInstructions", irrigationInstructions);
        this.$store.commit("modal2", true);
      } else {
        console.log("chomp");
        let payload = {
          subProjectId: this.$store.state.subProjectId,
          startDate: moment(new Date()).format("YYYY-MM-DD"),
          endDate: moment()
            .add(1, "days")
            .format("YYYY-MM-DD"),
        };

        this.$store.dispatch("getIrrigationInstructions", payload);
        this.$store.commit("modal2", true);
      }
    },
    onClick: async function() {
      // SELECT DATE FROM CALENDAR
      let payload = {
        subProjectId: this.$store.state.subProjectId,
        startDate: moment(this.date).format("YYYY-MM-DD"),
        endDate: moment(this.date)
          .add(1, "days")
          .format("YYYY-MM-DD"),
      };

      this.$store.dispatch("getIrrigationInstructions", payload);
      this.$store.commit("modal2", true);
    },
  },
};
</script>

<style scoped>
.v-card {
  /* height: 600px !important; */
}

.v-icon {
  margin-right: 7px !important;
}
</style>
